<template>
  <div :id="'relationListWidget'+$root.id">
    <relationList :contentid="$root.id" :newsid="$root.newsid" :productid="$root.productid" :settings="$root.settings" :admin="$root.admin" :attr="$root.attr" />
  </div>
</template>

<script>
import relationList from './components/relationList.vue'

export default {
  name: 'App',
  components: {
    relationList
  },
}
</script>
